import { render } from "./SideBar.vue?vue&type=template&id=30c9199a&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=30c9199a&scoped=true&lang=css"
import "./SideBar.vue?vue&type=style&index=1&id=30c9199a&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c9199a"]])

export default __exports__